import React from "react";
import { Link } from "react-router-dom";
import heroLight from "../assets/hero_image_light.webp";
import heroDark from "../assets/hero_image_dark.webp";

export default function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-gray-100 bg-white dark:border-gray-800 dark:bg-gray-950">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:flex lg:items-center lg:gap-16 lg:px-8 lg:py-28">
        <div className="w-full max-w-xl lg:shrink-0">
          <span className="mb-4 inline-flex items-center rounded-full border border-indigo-200 bg-indigo-50 px-3 py-1 text-xs font-medium text-indigo-700 dark:border-indigo-800 dark:bg-indigo-950 dark:text-indigo-400">
            Trusted by landlords across Kenya
          </span>
          <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl lg:text-6xl">
            Rent tracking
            <br />
            <span className="text-indigo-600">made effortless</span>
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-gray-600 dark:text-gray-400">
            Paysafi helps landlords and property managers track rent, manage tenants, send
            automated reminders, and stay on top of payments, all from one simple dashboard.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link to="/signup" className="btn-primary text-base px-6 py-3">
              Get started
            </Link>
            <a href="#how-it-works" className="btn-secondary text-base px-6 py-3">
              See how it works
            </a>
          </div>
        </div>
        <div className="mt-10 lg:mt-0 lg:flex-1">
          {/* Two <img> tags toggled via Tailwind dark: variants so the
              theme switch is instant — no JS-driven src swap that would
              re-trigger a fetch. Both webp assets download on first
              paint; the inactive one is hidden via CSS. */}
          <img
            src={heroLight}
            alt="Paysafi dashboard showing rent collection and tenant overview"
            width={1536}
            height={1024}
            loading="eager"
            decoding="async"
            fetchpriority="high"
            className="mx-auto w-full max-w-lg rounded-2xl drop-shadow-lg dark:hidden lg:max-w-none"
          />
          <img
            src={heroDark}
            alt="Paysafi dashboard showing rent collection and tenant overview"
            width={1536}
            height={1024}
            loading="eager"
            decoding="async"
            className="mx-auto hidden w-full max-w-lg rounded-2xl drop-shadow-lg dark:block lg:max-w-none"
          />
        </div>
      </div>
    </section>
  );
}
